module.exports = __webpack_public_path__ + "static/media/developer.78cbb226.svg";